import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 盒子新埋点数据收集
interface CollectJson {
    i?: string;
    d?: string;
    t?: string;
}
export const boxCollect = (json: CollectJson): any =>
    http.httpPost({
        url: httpApi.collect.collect,
        json,
    });
